import type { UpdateFusionConfig } from '@wf-coe/types';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';
import type { FusionConfigDto } from './use-fusion-configs.js';

interface UpdateFusionConfigInput {
  clientId: string;
  configId: string;
  patch: UpdateFusionConfig;
}

/** Mutation for `PUT /v1/clients/{clientId}/fusion-configs/{configId}`. */
export function useUpdateFusionConfigMutation(): UseMutationResult<
  FusionConfigDto,
  Error,
  UpdateFusionConfigInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, configId, patch }: UpdateFusionConfigInput) => {
      if (!api) throw new Error('useUpdateFusionConfigMutation: api client unavailable');
      return api.put<FusionConfigDto>(`/v1/clients/${clientId}/fusion-configs/${configId}`, patch);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['fusion-configs', clientId] });
    },
  });
}
